exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ConfiguracionAlarmas .estilo-grilla {\n  height: 100% !important;\n}\n", ""]);

// exports
